import { IReportGroup } from "../../../../reporting/interfaces/IReportGroup";
import { MachineGateway } from "../../models/machine";
import {
  MachineConfigurationGateway,
  MachineGameConfigurationGateway,
} from "../../models/machineConfiguration";

export class MachineConfigurationViewComponentController {
  readonly machine!: MachineGateway;
  readonly machineConfiguration!: MachineConfigurationGateway;
  readonly reportGroup!: IReportGroup;

  constructor() {}

  $onInit() {}

  getGameProgramNumber(gameConfig: MachineGameConfigurationGateway) {
    return (
      (gameConfig.GameProgramNumber === undefined
        ? ""
        : `${gameConfig.GameProgramNumber} `) +
      (gameConfig.GameProgramVersion ?? "")
    );
  }
}
